<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="input-group input-group-sm" style="width: 250px;">
            <div class="input-group-append">
              <button type="submit" class="btn btn-default" (click)="export()" >Export
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 300px;">
            <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right" placeholder="Search">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>

            <select type="text" name="table_search" [(ngModel)]="sortby" class="form-control float-right">
              <option value="id">id</option>
              <option value="name">Name</option>
              <option value="phone">Phone</option>
            </select>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-sort"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
      <div class="card-body table-responsive p-0" style="height: 410px;">
        <table class="table table-head-fixed text-nowrap" #customerTable>
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Contact Number</th>
              <th>Property ID</th>
              <th>Property Cost</th>
              <th>Remaining Amount</th>
              <th>Sales Officer</th>
              <th>Sales date</th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="!isloading">
            <tr *ngFor="let customer of customers | filter: searchString: 'status' | sort: [ sortby,''] ">
              <td>{{ customer.name }}</td>
              <td>{{ customer.contact_1 }}</td>
              <td>{{ customer.pid }}</td>
              <td>{{customer.property_cost |  currency:'INR'}}</td>
              <td>{{customer.remaining_balance | currency:'INR'}}</td>
              <td>{{customer.sale_person?.name}}</td>
              <td>{{customer.createdAt| date:'longDate'}}</td>
              <td>
                <a class="btn" (click) = "info(customer._id)"><i class="fas fa-info"></i></a>
                <a class="btn" (click) = "delete(customer)"
                 *ngIf="currentUser.role ==='admin'">
                  <i class="fas fa-trash"></i></a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="isloading">
            <td class="text-center" colspan="8"> loading ...</td>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
